import { render, staticRenderFns } from "./SupplierReturnMatrix.vue?vue&type=template&id=7ed64fd2&"
import script from "./SupplierReturnMatrix.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports